export default __webpack_public_path__ + "static/media/NEETTonic.70b62449a9d3aae22794029f1f4ebacd.webp";